import { Box, Button, ListItem } from '@mui/material'
import Header from 'components/Header'
import ListNavigation from 'components/ListNavigation'
import { dailyOrderOperations } from 'constant'
import { useNavigate, useParams } from 'react-router-dom'
import { isWarehouseM, isWarehouseSO } from 'utils/userUtils'

const DailyOrderSelect = () => {
  const { company } = useParams()
  const navigate = useNavigate()

  return (
    <Box>
      <Header />
      <ListNavigation elements={dailyOrderOperations} company={company!} />
      {!isWarehouseSO() && !isWarehouseM() && (
        <ListItem
          sx={{ padding: '40px 20px' }}
          onClick={() => {
            navigate(`/${company}/daily-order/manage-daily-order`)
          }}
        >
          <Button
            variant='contained'
            sx={{
              width: '100%',
              textAlign: 'center',
              textTransform: 'none',
              fontSize: '26px',
              padding: '50px 20px',
              backgroundColor: '#364c63'
            }}
          >
            Manage Daily Order
          </Button>
        </ListItem>
      )}
    </Box>
  )
}

export default DailyOrderSelect
